import { render, staticRenderFns } from "./tiezhiList.vue?vue&type=template&id=4dacf214"
import script from "./tiezhiList.vue?vue&type=script&lang=js"
export * from "./tiezhiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports